import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const Container = styled.div`
  width: 100%;
  background-color: white;
  grid-area: footer;
  font-size: 12px;
  display: none;
  
  @media (min-width: ${breakpoints.desktop}) {
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
  display: block;
  }
`;

export const Text = styled.p`
  color: #7a7a7a;
  margin: 5px 0px;
  float: right;
`;

export const Links = styled.ul`
  list-style-type: none;
  margin: 5px 0px;
  padding: 0;
  overflow: hidden;
`;

export const Item = styled.li`
  margin: 0;
  color: #7a7a7a;
  float: left;
`;

export const Link = styled.a`
  color: #7a7a7a;
  
  &:hover {
    text-decoration: underline;
    color: black;
  }
`;
